<template>
  <div v-if="liste.length" class="card border-info shadow-sm mb-3 resultats-a-voir">
    <div class="card-header bg-info-subtle d-flex justify-content-between align-items-center flex-wrap gap-2">
      <strong><i class="bi bi-clipboard2-data me-1"></i>Nouveaux résultats d'examens ({{ liste.length }})
        <span v-if="anormaux" class="badge bg-danger ms-1">{{ anormaux }} anormal(aux)</span></strong>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-outline-secondary" @click="ouvert = !ouvert">{{ ouvert ? 'Masquer' : 'Afficher' }}</button>
        <button class="btn btn-sm btn-outline-success" :disabled="envoi" @click="marquer([])"><i class="bi bi-check2-all me-1"></i>Tout marquer vu</button>
      </div>
    </div>
    <div v-if="ouvert" class="table-responsive">
      <table class="table table-sm align-middle mb-0">
        <thead><tr><th>Validé le</th><th>Patient</th><th>Examen</th><th>Résultat</th><th></th></tr></thead>
        <tbody>
          <tr v-for="r in liste" :key="r.id" :class="{ 'table-danger': r.anormal }">
            <td class="text-nowrap small">{{ date(r.valideAt) }}</td>
            <td>{{ r.patient?.nom }}<div class="small text-muted">{{ r.patient?.numeroDossier }}</div></td>
            <td>{{ r.type }}<span v-if="r.anormal" class="badge bg-danger ms-1">Anormal</span></td>
            <td class="small">
              <div v-for="l in (r.resultatsDetailles || []).slice(0, 4)" :key="l.nom" :class="{ 'text-danger fw-semibold': l.anormal }">{{ l.nom }} : {{ l.valeur }} {{ l.unite }}</div>
              <div v-if="(r.resultatsDetailles || []).length > 4" class="text-muted">…</div>
              <div v-if="r.conclusion" class="text-muted">{{ r.conclusion }}</div>
            </td>
            <td class="text-end text-nowrap">
              <router-link v-if="r.consultation" class="btn btn-sm btn-outline-primary me-1" :to="{ name: 'traitement_consultation', params: { id: r.consultation.id } }"
                           :title="r.consultation.cloturee ? 'Ouvrir la consultation pour ajouter un complément' : 'Ouvrir la consultation'">
                <i class="bi bi-box-arrow-up-right"></i>
              </router-link>
              <button class="btn btn-sm btn-outline-success" title="Vu" :disabled="envoi" @click="marquer([r.id])"><i class="bi bi-check2"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import api, { messageErreur, notifier } from '@/api'

/**
 * Résultats validés par le laboratoire que le médecin n'a pas encore vus
 * (ses prescriptions et ses patients). Rafraîchi toutes les 2 minutes.
 */
export default {
  name: 'ResultatsAVoir',
  data() {
    return { liste: [], ouvert: true, envoi: false, minuteur: null }
  },
  computed: {
    anormaux() { return this.liste.filter(r => r.anormal).length },
  },
  created() {
    if (!this.$store.getters.hasPermission('CONSULT_TRAITER')) return
    this.charger()
    this.minuteur = setInterval(this.charger, 120000)
  },
  beforeUnmount() {
    clearInterval(this.minuteur)
  },
  methods: {
    async charger() {
      try {
        this.liste = (await api.custom('mes-resultats', 'GET')).data?.data || []
      } catch (e) {
        this.liste = []
      }
    },
    async marquer(ids) {
      this.envoi = true
      try {
        this.liste = (await api.post('mes-resultats/vus', { ids })).data?.data || []
      } catch (e) {
        notifier(messageErreur(e))
      } finally {
        this.envoi = false
      }
    },
    date(d) { return d ? dayjs(d).format('DD/MM HH:mm') : '' },
  },
}
</script>
